export default "__VITE_ASSET__73e04e2a__"